import React from 'react';
import C from '../colors';

const feeItems = [
  {
    title: '支付与结算服务费',
    rate: '1%',
    description: '用于支付通道收款、资金结算及提现处理，按本次提现申请金额的 1% 计算。',
  },
  {
    title: '平台技术服务费',
    rate: '0%',
    badge: '限免',
    description: '图片管理、在线选片与订单服务目前不收取平台技术服务费。',
  },
];

export default function WithdrawalFeeNotice({ compact = false }) {
  return (
    <section data-testid="withdrawal-fee-notice" aria-label="提现费用说明" style={{
      display: 'grid', gridTemplateColumns: compact ? '1fr' : 'repeat(2, minmax(0, 1fr))',
      gap: compact ? 8 : 12,
    }}>
      {feeItems.map(item => (
        <div key={item.title} style={{
          padding: compact ? '11px 13px' : '15px 17px',
          background: '#fff', border: `1px solid ${C.hair}`,
          borderRadius: 11, textAlign: 'left',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <span style={{ fontFamily: C.sans, fontSize: compact ? 12 : 13, fontWeight: 600, color: C.ink2 }}>
              {item.title}
            </span>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
              <strong style={{ fontFamily: C.mono, fontSize: compact ? 14 : 16, color: item.badge ? C.brand2 : C.ink }}>
                {item.rate}
              </strong>
              {item.badge && (
                <span style={{
                  padding: '2px 6px', borderRadius: 999,
                  background: '#FFF0F7', border: `1px solid ${C.brand}55`,
                  color: C.brand2, fontFamily: C.sans, fontSize: 10, fontWeight: 600,
                }}>{item.badge}</span>
              )}
            </span>
          </div>
          <p style={{ margin: '7px 0 0', fontFamily: C.sans, fontSize: compact ? 10.5 : 11.5, lineHeight: 1.6, color: C.ink3 }}>
            {item.description}
          </p>
        </div>
      ))}
    </section>
  );
}
